import { Wrench, Wind, Stethoscope, Siren } from "lucide-react";

export const NAV_LINKS = [
  { label: "How it works", href: "#how-it-works" },
  { label: "Built for service", href: "#industries" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const PHONE_DISPLAY = "325.433.0086";
export const PHONE_TEL = "+13254330086";

export const INDUSTRY_STRIP = [
  { label: "Plumbing", icon: Wrench },
  { label: "HVAC", icon: Wind },
  { label: "Dental", icon: Stethoscope },
  { label: "Emergency", icon: Siren },
];

export const PROBLEM_CARDS = [
  {
    title: "Coverage when your team is unavailable",
    body: "After-hours, overflow, and no-answer calls receive an immediate, professional response.",
  },
  {
    title: "A consistent answer every time",
    body: "Your service information and FAQs shape every conversation, so callers hear a unified message.",
  },
  {
    title: "Urgency moves to the front",
    body: "Each call is captured, organized, and prioritized so your team knows what needs action first.",
  },
];

export const HANDOFF_STEPS = {
  after: [
    { n: "01", title: "Caller reaches you", body: "CallRetrieve answers right away." },
    { n: "02", title: "AI steps in", body: "The caller explains the situation in a natural conversation." },
    { n: "03", title: "Details are triaged", body: "The caller's need, location, and urgency are captured in the right order." },
    { n: "04", title: "Your team is alerted", body: "A clean summary reaches the right person, ready for a fast response." },
  ],
  business: [
    { n: "01", title: "Your line rings first", body: "Calls reach your team exactly the way they do today." },
    { n: "02", title: "Overflow is covered", body: "When no one can pick up, CallRetrieve answers instantly." },
    { n: "03", title: "Details are captured", body: "The caller's need, location, and urgency are organized for you." },
    { n: "04", title: "Your team follows up", body: "A clean summary is ready the moment your team is free." },
  ],
};

export const DIFFERENCE_CARDS = [
  {
    title: "Your message, unified",
    body: "Business details, service boundaries, FAQs, and preferred language are configured into the call experience.",
    link: "Learn about unified messaging",
  },
  {
    title: "Priorities you define",
    body: "Urgent, high-priority, and routine calls can follow the response logic that makes sense for your operation.",
    link: "Learn about priority rules",
  },
  {
    title: "Your business owns its data",
    body: "Call data, recordings, and transcripts produced for your account belong to your business under the service agreement.",
    link: "Learn about data ownership",
  },
];

export const PRICING = {
  eyebrow: "Simple to start",
  setup: "$1,499",
  setupNote1: "one-time setup",
  setupNote2: "for a single location",
  monthly: "$399",
  monthlyNote1: "per month",
  monthlyNote2: "for ongoing service",
  included: [
    "Guided business setup",
    "Call logic & escalation rules",
    "Ongoing service coverage",
  ],
};

export const FIT_CARDS = [
  {
    n: "01",
    title: "Plumbing",
    body: "Separate leaks, backups, no-water calls, and routine requests so urgent work is visible first.",
    icon: Wrench,
    theme: "navy",
  },
  {
    n: "02",
    title: "HVAC",
    body: "Capture system issues, location details, occupancy concerns, and after-hours service needs.",
    icon: Wind,
    theme: "lime",
  },
  {
    n: "03",
    title: "Dental",
    body: "Offer a calm first response, gather the caller's need, and move urgent requests toward the right follow-up.",
    icon: Stethoscope,
    theme: "coral",
  },
  {
    n: "04",
    title: "Emergency",
    body: "Keep the customer connected while your response process identifies the need and notifies the right person.",
    icon: Siren,
    theme: "teal",
  },
];

export const FAQS = [
  {
    q: "Does CallRetrieve replace my staff?",
    a: "No. It covers the moments your team cannot answer, follows your call logic, and gives your staff a structured summary to act on.",
  },
  {
    q: "Can it use my business's own answers?",
    a: "Yes. Your business details, service boundaries, FAQs, and preferred language are configured into every conversation so callers hear your message.",
  },
  {
    q: "What happens during business hours?",
    a: "Calls your team can't reach in time are answered as overflow, captured in order, and handed back with a clean summary.",
  },
  {
    q: "What happens after hours?",
    a: "CallRetrieve answers immediately, understands the caller's need and urgency, and notifies the right person on your team.",
  },
];

export const BUSINESS_TYPES = [
  "Plumbing",
  "HVAC",
  "Dental",
  "Emergency service",
  "Other service business",
];
